import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import "./PollResultsTVPage.css";

export default function PollResultsTVPage() {
  const { slug } = useParams();
  const [poll, setPoll] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    const load = () =>
      api.get(`/polls/by-slug/${slug}`, { params: { results: true } })
        .then((r) => setPoll(r.data))
        .catch((e) => { if (e.response?.status === 404) setNotFound(true); });
    load();
    const iv = setInterval(load, 5000);
    return () => clearInterval(iv);
  }, [slug]);

  if (notFound) {
    return (
      <div className="polltv-root polltv-dark">
        <div className="polltv-stage">
          <div className="polltv-empty">Encuesta no encontrada</div>
        </div>
      </div>
    );
  }
  if (!poll) return <div className="polltv-root polltv-dark" data-testid="poll-tv-loading" />;

  const theme = poll.results_theme || "dark";
  const bgType = poll.results_bg_type || "solid";
  const bgStyle = bgType === "image" && poll.results_bg_image
    ? { backgroundImage: `url(${poll.results_bg_image})`, backgroundSize: "cover", backgroundPosition: "center" }
    : bgType === "transparent"
    ? { background: theme === "dark" ? "#0b1220" : "#f5f5f5" }
    : { background: poll.results_bg_color || (theme === "dark" ? "#0b1220" : "#f5f5f5") };

  const options = (poll.options || []).slice().sort((a, b) => (b.votes || 0) - (a.votes || 0));
  const total = poll.total_votes || 0;
  const hideTotals = !!poll.results_hide_totals;
  const count = options.length;
  const gridCols = count <= 2 ? 2 : count <= 4 ? 2 : count <= 6 ? 3 : 4;
  const gridRows = Math.ceil(count / gridCols);

  return (
    <div className={`polltv-root polltv-${theme}`} data-testid="poll-tv-page">
      <div className="polltv-stage" style={bgStyle}>
        <header className="polltv-header">
          <div className="polltv-live">
            <span className="polltv-dot" />
            <span>EN VIVO</span>
          </div>
          <h1 className="polltv-title" data-testid="poll-tv-title">{poll.title}</h1>
          {poll.question && <p className="polltv-question">{poll.question}</p>}
          {!hideTotals && (
            <div className="polltv-total" data-testid="poll-tv-total">
              <strong>{total.toLocaleString("es-BO")}</strong>
              <span>{total === 1 ? "voto total" : "votos totales"}</span>
            </div>
          )}
        </header>

        <div
          className="polltv-grid"
          style={{
            gridTemplateColumns: `repeat(${gridCols}, minmax(0, 1fr))`,
            gridTemplateRows: `repeat(${gridRows}, minmax(0, 1fr))`,
          }}
        >
          {options.map((o, i) => {
            const pct = Number(o.pct || 0);
            const isLeader = i === 0 && (o.votes || 0) > 0;
            return (
              <div
                key={o.id}
                className={`polltv-card ${isLeader ? "leader" : ""}`}
                data-testid={`poll-tv-option-${o.id}`}
              >
                {o.image ? (
                  <div className="polltv-photo">
                    <img src={o.image} alt={o.text} />
                  </div>
                ) : (
                  <div className="polltv-photo polltv-photo-placeholder">
                    <span>{(o.text || "?").slice(0, 1).toUpperCase()}</span>
                  </div>
                )}
                <div className="polltv-card-body">
                  <div className="polltv-name">{o.text}</div>
                  <div className="polltv-bar">
                    <div className="polltv-fill" style={{ width: `${pct}%` }} />
                  </div>
                  <div className="polltv-stats">
                    <span className="polltv-pct" data-testid={`poll-tv-pct-${o.id}`}>{pct.toFixed(1)}%</span>
                    {!hideTotals && (
                      <span className="polltv-votes">{(o.votes || 0).toLocaleString("es-BO")} {(o.votes || 0) === 1 ? "voto" : "votos"}</span>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
